import React from 'react'
import { motion } from "framer-motion";
import { useState } from 'react';

const FullImage = ({ title, content, image, close }) => {
    const variants = {
        hidden: i => ({

            transform: "translate(100%)",
            transitionEnd: {
                display: "none",
            },
            transition: {
                duration: .7
            }
        }), visible: i => ({
            display: "block",
            transform: "translate(0)",
            transition: {
                duration: .7
            }
        })
    }

    const variants_ico = {
        hidden: i => ({
            transform: "rotate(0)",

        }), visible: i => ({
            transform: "rotate(180deg)",
            transition: {
                delay: 1
            }
        })
    }

  

    const [extended, setExtended] = useState(false)
    return (
        <motion.div initial="hidden" animate={extended ? "visible" : "hidden"} className=" w-full relative overflow-hidden" style={{ height: "calc(100vh - 65px)" }}>

            <img src={`./izba_zdjecia/${image}.jpg`} className="w-full h-full object-cover rounded-md" alt="" />
            {
                title !== null && content !== null?
            <div className="flex items-center bg-slate-700 w-fit absolute top-5 left-5 gap-2 rounded-full" onClick={() => {
                setExtended(true)
            }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-info-circle-fill" viewBox="0 0 16 16">
                    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2" />
                </svg>
                <div className="font-bold pe-3">
                    Klikniij i dowiedz się więcej
                </div>
            </div>

                :
                <></>
            }

            <div className="absolute top-5 right-5" >
                {close}
            </div>

            <motion.div variants={variants} className=" absolute w-full h-full top-0 left-0 bg-slate-800 py-3 px-5">
                <div>
                    <div className='ms-auto flex items-center gap-3 bg-slate-600 w-fit rounded-full' onClick={() => {
                        setExtended(false)
                    }}>
                        <motion.div className='ps-3'>
                            Zamknij
                        </motion.div>
                        <motion.svg afterChildren variants={variants_ico} xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#cbd5e1" class="bi bi-arrow-bar-left" viewBox="0 0 16 16">
                            <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m3.5 7.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z" />
                        </motion.svg>

                    </div>
               
                    <div className='text-2xl font-bold text-center'>{title}</div>
                    <div className='pt-3 text-justify'>{content}</div>
                </div>
            </motion.div>

        </motion.div>
    )
}

export default FullImage